import React from 'react'
import { useSelector } from 'react-redux'
import MovieList from './MovieList'

const SecondaryContainer = () => {
  const movies = useSelector((store)=> store.movies)
  return (movies && (
    <div className='bg-neutral-950 w-full '>
      <div className=' mt-0 pl-1 sm:mt-0  md:-mt-60 md:pl-9 z-20 relative'>
        <MovieList title ={'Recommended'} Movies={movies?.RecomendedMovies}/>
        <MovieList title ={'Now playing'} Movies={movies?.nowPlayingMovies}/>
        <MovieList title ={'TopRatedMovies'} Movies={movies?.TopRatedMovies}/>
        <MovieList title ={'Popular Movies'} Movies={movies?.PopularMovies}/>
        <MovieList title ={'Upcoming Movies'} Movies={movies?.nowPlayingMovies}/>
       </div>
    </div>)
  )
}

export default SecondaryContainer